import { isProgrammaticAccount } from '../../../account-management/accountType';

export const supportProgrammaticCampaigns = ({ selectedAccount, isRealtime }) =>
    isProgrammaticAccount(selectedAccount) && !isRealtime;
